import React, { createContext, useContext, useEffect, useState, useMemo } from "react";

const CartCtx = createContext(null);
const STORAGE_KEY = "immuski_cart_v1";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      const raw = localStorage.getItem(STORAGE_KEY);
      return raw ? JSON.parse(raw) : [];
    } catch { return []; }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const add = (product, opts = {}) => {
    const { quantity = 1, subscription = null } = opts;
    setItems((prev) => {
      const key = product.id + "|" + (subscription || "onetime");
      const idx = prev.findIndex((it) => it.key === key);
      if (idx >= 0) {
        const copy = [...prev];
        copy[idx] = { ...copy[idx], quantity: copy[idx].quantity + quantity };
        return copy;
      }
      const unit = subscription
        ? Math.round(product.price * (1 - (product.subscription_discount_pct || 10) / 100))
        : product.price;
      return [
        ...prev,
        {
          key,
          product_id: product.id,
          slug: product.slug,
          name: product.name,
          image: product.hero_image,
          price: unit,
          list_price: product.price,
          quantity,
          subscription,
        },
      ];
    });
    setOpen(true);
  };

  const remove = (key) => setItems((prev) => prev.filter((it) => it.key !== key));
  const updateQty = (key, quantity) =>
    setItems((prev) => prev.map((it) => (it.key === key ? { ...it, quantity: Math.max(1, quantity) } : it)));
  const clear = () => setItems([]);

  const totals = useMemo(() => {
    const subtotal = items.reduce((s, it) => s + it.price * it.quantity, 0);
    const count = items.reduce((s, it) => s + it.quantity, 0);
    return { subtotal, count };
  }, [items]);

  return (
    <CartCtx.Provider value={{ items, add, remove, updateQty, clear, open, setOpen, totals }}>
      {children}
    </CartCtx.Provider>
  );
}

export const useCart = () => useContext(CartCtx);
